import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

/**
 * Form field wrapper that enforces label/control association (a11y) and standardizes
 * hint + error rendering.
 *
 * <FormField label="Email" htmlFor="email" required error={errors.email}>
 *   <Input id="email" ... />
 * </FormField>
 *
 * props: label, htmlFor (required), required?, error?, hint?, children
 */
export function FormField({ label, htmlFor, required, error, hint, children, className }) {
  return (
    <div className={cn("space-y-1.5", className)}>
      {label && (
        <Label htmlFor={htmlFor} className="text-sm font-medium text-slate-700">
          {label}
          {required && <span className="ml-0.5 text-red-500" aria-hidden="true">*</span>}
        </Label>
      )}
      {children}
      {hint && !error && <p className="text-xs text-slate-500">{hint}</p>}
      {error && <p className="text-xs text-red-600">{error}</p>}
    </div>
  );
}

export default FormField;
